import React from "react"

import ProductPage from "../../components/product_page"

const product = "fencing-flashing"

const Page = () => <ProductPage product={product} />

export default Page
